import { Fragment, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

const Circular = ({ clickCircular, setClickCircular, circularOpen, setCircularOpen, source, width = 'sm:w-full sm:max-w-sm', bgColor = 'bg-primarioMira',  paddingTop = 'sm:my-8 sm:p-6 pt-5' }) => {


    useEffect(() => {
        setCircularOpen(true)
    }, [])
    

  return (
    <>
                <>
                {circularOpen?
                 
                <Transition.Root show={circularOpen} as={Fragment} className="block overflow-scroll">
                  <Dialog
                    as="div"
                    className="relative z-10"
                    onClose={() => !circularOpen}
                  >
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div
                        className={
                          `fixed inset-0 bg-secundarioMira `
                        }
                      />
                    </Transition.Child>

                    <div className="fixed inset-0 z-30 overflow-y-auto">
                      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                          enterTo="opacity-100 translate-y-0 sm:scale-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                          leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            {/* relative transform overflow-hidden rounded-lg ${bgColor} px-4 ${paddingTop} pb-4 text-left shadow-xl transition-all ${width} */}
                          <div
                            className={`z-100 w-[90%] xl:w-[30%]`}
                          >
                            

                              
                                
                                
                                  
                                    <div className="text-center">
                                      <img src={source}></img>
                                    </div>
                                  
                                    <button
                                onClick={() =>{setCircularOpen(false); setClickCircular(() => clickCircular + 1)}
                                }
                                type="button"
                                className="mt-2 inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                            >
                                Entendido
                            </button>
                              
                            
                            {/* children */}
                          </div>
                        </Transition.Child>
                      </div>
                    </div>
                    
                  </Dialog>
                </Transition.Root>
                :null}
                </>
              
      

    </>
  );
};

export default Circular;